export default {
    onlineOrder: 'Onlinebestellung',
    supplier: 'Lieferant',
    offerNumber: 'Angebotsnummer',
    offerDate: 'Angebotsdatum',
    orderDate: 'Bestelldatum',
    validUntil: 'Gültig bis',
    gross: 'Brutto',
    net: 'Netto',
    deliveryCosts: 'Lieferkosten',
    otherCosts: 'Sonstige Kosten',
    taxes: 'Steuern',
    total: 'Gesamtsumme',
    remarks: 'Bemerkungen',
    hideRemarks: 'Bemerkungen ausblenden',
    addRemarks: 'Bemerkungen hinzufügen',
    contactPerson: 'Ansprechperson'
}
